import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomizationGroup } from 'src/app/interfaces/customization-group';
import { PreviewerType } from 'src/app/types/previewer.type';

@Component({
  selector: 'app-customizer-tab-bar',
  templateUrl: './customizer-tab-bar.component.html',
  styleUrls: ['./customizer-tab-bar.component.scss']
})
export class CustomizerTabBarComponent {
  @Input() customizationGroups: CustomizationGroup[] = [];
  @Output() selectedCustomizationGroupChange = new EventEmitter<number>();
  @Output() selectedPreviewerChange = new EventEmitter<PreviewerType>();

  groupSelected(selectedGroup: CustomizationGroup) {
    const selectedIndex = this.customizationGroups.findIndex(group => selectedGroup.name === group.name);
    this.selectedCustomizationGroupChange.emit(selectedIndex);
    this.selectedPreviewerChange.emit(selectedGroup.link === '/summary' ? 'Summary' : 'Preview');
  }
}
